import React from "react";
import { observer } from "mobx-react";
import CallsUtils from "Utils/CallsUtils";
import DateUtils from "Utils/DateUtils";
import ConstantObj from "Static/constant";

const getFormattedDate = (createTs = "") => {
  if (!createTs) return "--";
  const d = new Date(createTs);
  return `${ConstantObj?.months?.[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}`;
};

const CallListItem = observer(({ call = {}, selected = false, onClick }) => {
  const {
    contactName = "",
    memberName = "",
    outcome = "",
    createTs = "",
    duration = 0,
    recordingUrl = ""
  } = call;

  const formattedDuration = CallsUtils.secondsToTime(duration);
  const formattedDate = getFormattedDate(createTs);

  return (
    <div
      className={`callListItem${selected ? " callListItem--selected" : ""}`}
      onClick={onClick}
    >
      <div className="callListItem__top">
        <div className="callListItem__info">
          <span className="callListItem__name">{contactName || "--"}</span>
          <span className="callListItem__calledBy">{memberName || "--"}</span>
        </div>
        <span className={`callListItem__outcome callListItem__outcome--${(outcome || "").toLowerCase().replace(/\s+/g, "-")}`}>
          {outcome || "--"}
        </span>
      </div>
      <div className="callListItem__meta">
        <span className="callListItem__date">{formattedDate}</span>
        <span className="callListItem__dot">·</span>
        <span className="callListItem__duration">{formattedDuration}</span>
        {recordingUrl && (
          <span className="callListItem__recBadge">
            <i className="material-icons">play_circle_outline</i>
            Rec
          </span>
        )}
      </div>
    </div>
  );
});

export default CallListItem;
